import Paper from '@mui/material/Paper';
import { Box, Divider } from '@mui/material';
import { ContextSelect } from '../../component/ContextSelect';
import { useState } from 'react';
import { CreateIngredientForm } from '../../component/CreateIngredientForm';
import { CreateProductForm } from '../../component/CreateProductForm';
import { CreateRebox } from '../../component/CreateRebox';
import { CustomerSelector } from '../../component/CustomerSelector';
import { customerRole } from '../../enum/customerRole';


const NftCreation = () => {
    const [state, setState] = useState({
        context: '',
        role: '',
        customer: '',
    });
    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box sx={{width: '100%'}}>
                <ContextSelect onContextChange={context => changeState({context})}/>
                <CustomerSelector
                    context={state.context}
                    roles={[customerRole.supplier, customerRole.producer, customerRole.distributor]}
                    onChangeRole={role => changeState({role})}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Divider variant="fullWidth" sx={{mt: 2, mb: 1, borderWidth: '2px'}}/>
                {state.role === customerRole.supplier && (
                    <CreateIngredientForm customer={state.customer}/>
                )}
                {state.role === customerRole.producer && (
                    <CreateProductForm customer={state.customer}/>
                )}
                {state.role === customerRole.distributor && (
                    <CreateRebox customer={state.customer}/>
                )}
            </Box>
        </Paper>
    );
};

export default NftCreation;
